import { render, staticRenderFns } from "./m-document-cancel.vue?vue&type=template&id=466dd36d&scoped=true&lang=pug"
import script from "./m-document-cancel.vue?vue&type=script&lang=js"
export * from "./m-document-cancel.vue?vue&type=script&lang=js"
import style0 from "./m-document-cancel.vue?vue&type=style&index=0&id=466dd36d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466dd36d",
  null
  
)

export default component.exports